"use client";

import { useEffect } from "react";
import { Track } from "@/src/lib/tracking";
import { usePathname } from "@/src/hooks/usePathname";
import { consumeAdLinkOpenCookie } from "@/src/utils/onboarding/adLinkOpen.client";

/**
 * 全局挂载：Proxy 捕获广告链接参数后（`OnboardingStepGate`），在客户端补发 `ad_link_open`。
 *
 * keyed on pathname 而非只挂一次：Proxy 也会处理客户端路由的请求，cookie 可能在首帧之后才落；
 * 每次只读一个 cookie，没有就立即返回，开销可忽略。
 */
export const useAdLinkOpenTracking = (): void => {
  const pathname = usePathname();
  useEffect(() => {
    // 埋点失败绝不冒到根布局（RootLayoutClient）
    try {
      consumeAdLinkOpenCookie();
    } catch (error) {
      Track.log("warn", "useAdLinkOpenTracking", "consume failed", {
        error: error instanceof Error ? error.message : String(error),
      });
    }
  }, [pathname]);
};
